import { createTheme } from '@material-ui/core/styles';


const theme = createTheme({
  palette: {
    primary: {
      main: '#6200EE',
    },
  },
  typography: {
    fontFamily: [
      'Jost'
    ].join(',')
  },
  overrides: {
    MuiTypography: {
      h4: {
        marginBottom: 20,
      }
    },
    MuiCssBaseline: {
      '@global': {
      }
    },
    MuiList: {
      root: {
        '& .MuiButton-root.active': {
          backgroundColor: '#eee6f9',
          borderLeft: '5px solid #6200e8',
        },
        '& .MuiButton-root': {
          borderRadius: 0,
        }
      }
    },
    MuiTableCell: {
      root: {
        padding: '15px 8px',
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'none',
        }
      }
    },
  }
});


export default theme;
